// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__16Icq","right":"styles_right__Ix7kY"};